<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  @charset "UTF-8";
  @import '../static/html/css/font_3575476_p34hs9wvu6o.css';
  @import '../static/html/css/font_3697915_9d0k8g05ckn.css';
  .el-select-dropdown .el-scrollbar .el-scrollbar__wrap{
    margin: 0 !important;
    overflow: hidden !important;
  }
  .elps{
    white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
  }
  .enlineHeight{
    line-height: 1.4vw !important;
  }
  .enlineHeight1{
    line-height: 1.9vw !important;
  }
  ul {
      margin: 0;
      padding: 0;
      list-style: none;
  }
  * {
      outline: none;
      margin:0;
  }
  body,
  html {
    font-size: -webkit-calc(100vw / 120);
    font-size: -moz-calc(100vw / 120);
    font-size: calc(100vw / 120);
  }

  @media (min-width: 1440px) and (max-width: 1920) {

    body,
    html {
      font-size: -webkit-calc(100vw / 110);
      font-size: -moz-calc(100vw / 110);
      font-size: calc(100vw / 110);
    }
  }

  @media (min-width: 1366px) and (max-width: 1440px) {

    body,
    html {
      font-size: -webkit-calc(100vw / 100);
      font-size: -moz-calc(100vw / 100);
      font-size: calc(100vw / 100);
    }
  }

  @media (min-width: 1024px) and (max-width: 1366px) {

    body,
    html {
      font-size: -webkit-calc(100vw / 90);
      font-size: -moz-calc(100vw / 90);
      font-size: calc(100vw / 90);
    }
  }

  @media (min-width: 767px) and (max-width: 1024px) {

    body,
    html {
      font-size: -webkit-calc(100vw / 80);
      font-size: -moz-calc(100vw / 80);
      font-size: calc(100vw / 80);
    }
  }

  @media (max-width: 767px) {

    body,
    html {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue